export default "__VITE_PUBLIC_ASSET__eda35171__"